/**
 * @file Discover Album Folder master view.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';

import ScrollToTop from '../../components/routing/ScrollToTop';
import OnboardingLayout from '../../apps/temp/views/onboarding/OnboardingLayout/OnboardingLayout';

const propTypes = {
  route: PropTypes.object,
};

const DiscoverAlbumFolderMasterView = ({ route }) => {
  return (
    <Fragment>
      <OnboardingLayout>
        {renderRoutes(route.routes)}
        <ScrollToTop />
      </OnboardingLayout>
    </Fragment>
  );
};

DiscoverAlbumFolderMasterView.propTypes = propTypes;

export default DiscoverAlbumFolderMasterView;
